module.exports = __webpack_public_path__ + "static/media/logo.99771473.gif";